import * as LJS from '../../lib/littlejs.esm.js';
import { vec2 } from '../../lib/littlejs.esm.js';
import ldtkData from '../../assets/levels.ldtk';
import { saveData } from '../utils/storage.ts';
import { getCenterTextPos } from '../utils/font.ts';
import Globals from '../globals.ts';
let levels = [];
let selectedLevelIndex = 0;
let font = null;
function init() {
    levels = ldtkData.levels;
    font = new LJS.FontImage;
}
function update() {
    if (LJS.keyWasPressed('ArrowUp')) {
        selectedLevelIndex = Math.max(0, selectedLevelIndex - 1);
    }
    if (LJS.keyWasPressed('ArrowDown')) {
        selectedLevelIndex = Math.min(levels.length - 1, selectedLevelIndex + 1);
    }
    if (LJS.keyWasPressed('Space') || LJS.keyWasPressed(' ')) {
        return { levelIndex: selectedLevelIndex };
    }
    if (LJS.keyWasPressed('KeyE')) {
        Globals.epilepsySafe = !Globals.epilepsySafe;
        saveData("epilepsy_safe", Globals.epilepsySafe);
    }
    return 'none';
}
function render() {
    const titleText = 'FALLIN\' WELL';
    const titleX = getCenterTextPos(titleText, 4);
    font.drawTextScreen(titleText, vec2(titleX, LJS.mainCanvasSize.y / 2 - 200), 4);
    const scoreText = `Best depth : ${Globals.bestScore}`;
    const scoreX = getCenterTextPos(scoreText, 2);
    font.drawTextScreen(scoreText, vec2(scoreX, LJS.mainCanvasSize.y / 2 - 120), 2);
    /*
     * Epilepsy warning text
     */
    const epilWarningText1 = 'WARNING : This game may potentially trigger seizures';
    const epilWarningX1 = getCenterTextPos(epilWarningText1, 2);
    font.drawTextScreen(epilWarningText1, vec2(epilWarningX1, LJS.mainCanvasSize.y - 352), 2);
    const epilWarningText2 = 'for people with photosensitive epilepsy.';
    const epilWarningX2 = getCenterTextPos(epilWarningText2, 2);
    font.drawTextScreen(epilWarningText2, vec2(epilWarningX2, LJS.mainCanvasSize.y - 320), 2);
    const epilToggleText = 'You can toggle the epilepsy-safe mode by pressing "E".';
    const epilToggleX = getCenterTextPos(epilToggleText, 2);
    font.drawTextScreen(epilToggleText, vec2(epilToggleX, LJS.mainCanvasSize.y - 224), 2);
    const epilModeText = Globals.epilepsySafe ? 'Epilepsy-safe mode Enabled' : '';
    const epilModeX = getCenterTextPos(epilModeText, 2);
    font.drawTextScreen(epilModeText, vec2(epilModeX, LJS.mainCanvasSize.y - 192), 2);
    // Start text at the bottom of the screen
    const startText = 'Press SPACE to start';
    const startX = getCenterTextPos(startText, 2);
    font.drawTextScreen(startText, vec2(startX, LJS.mainCanvasSize.y - 80), 2);
}
function updatePost() { }
function renderPost() { }
export { init, update, updatePost, render, renderPost };
